<div class="page-not-found">
  <h1 class="page-not-found__title">{{ 'components.pageNotFound.labels.title' | translate }}</h1>
  <p class="page-not-found__description">{{ 'components.pageNotFound.labels.description' | translate }}</p>
  <h2 class="page-not-found__code">404</h2>
  <button tuiButton type="button" class="page-not-found__button" appearance="primary" routerLink="/">
    {{ 'components.pageNotFound.buttons.home' | translate }}
  </button>
</div>
